import { useState } from 'react';
import {
  useCreateOauthIntegration,
  useDeleteIntegration,
  useGetAvailableIntegrations,
  useGetIntegrations
} from 'apis/business/setting/integrations/hook';
import Spinner from 'components/Common/Spinner';
import Grid from '@mui/material/Grid2';
import { Box, Typography } from '@mui/material';
import Button from 'components/Common/Button';
import Search from 'components/Common/Search';
import IntegrationForm from './Components/IntegrationForm';

export default function Integrations() {
  const [isModalOpen, setIsModalOpen] = useState<any>(false);
  const [searchText, setSearchText] = useState<null | string>(null);

  const { data: availableIntegrations, isLoading: isAvailableIntegrationLoading } = useGetAvailableIntegrations({
    'filter[name_cont]': searchText
  });
  const { data: integrations, isLoading: isIntegrationLoading } = useGetIntegrations();
  const { mutateAsync: handleCreateIntegration } = useCreateOauthIntegration();
  const { mutateAsync: deleteIntegration } = useDeleteIntegration();

  const combinedData =
    availableIntegrations?.data?.map((item) => {
      const matchingIntegration = integrations?.data?.find((integration: any) => integration.code === item.code);
      return {
        ...item,
        active: matchingIntegration?.active ?? false,
        integrationId: matchingIntegration?.id
      };
    }) ?? [];

  const handleActiveIntegration = async (code: string) => {
    const integration = availableIntegrations?.data?.find((item: any) => item.code === code);
    if (integration?.connection_type === 'oauth') {
      handleCreateIntegration(code as any);
    } else {
      setIsModalOpen(code);
    }
  };

  if (isIntegrationLoading || isAvailableIntegrationLoading) {
    return <Spinner />;
  }

  return (
    <>
      <Box display='flex' justifyContent='space-between'>
        <Box>
          <Typography variant='h2' fontWeight={500} mb={1}>
            Integrations
          </Typography>
          <Typography color='secondary' fontSize={14}>
            Connect systems for efficiency and streamlined workflows. Simplify processes and increase productivity
            effortlessly.
          </Typography>
        </Box>
        <Search size='small' placeholder='Search' searchText={searchText} setSearchText={setSearchText} />
      </Box>
      <Grid container spacing={2} mt={3}>
        {combinedData?.map((item, index) => (
          <Grid
            key={index}
            size={{ xs: 12, md: 6, lg: 4 }}
            bgcolor='white'
            p={2}
            border='1px solid #ECECEC'
            borderRadius={2}
          >
            <img src={item.avatar_url} alt={item.name} style={{ maxHeight: 30 }} />
            <Typography my={1} color='secondary' fontSize={14}>
              {item.description}
            </Typography>
            <Box textAlign='right'>
              {item?.active ? (
                <Button onClick={() => deleteIntegration(item.integrationId!)} color='error'>
                  Deactivate
                </Button>
              ) : (
                <Button onClick={() => handleActiveIntegration(item.code)}>Activate</Button>
              )}
            </Box>
          </Grid>
        ))}
      </Grid>
      <IntegrationForm open={isModalOpen} handleClose={() => setIsModalOpen(false)} />
    </>
  );
}
